import { ArtData } from "./art";
import { DoridiumCheckout } from "./checkout";
import { LocationData } from "./location";
import { SITE_DATA_PARTITIONS } from "./siteTable";

export type OrderKey = {
  PK: typeof SITE_DATA_PARTITIONS.ORDER;
  SK: string;
};

export type OrderKeyComponents = {
  type: typeof SITE_DATA_PARTITIONS.ORDER;
  slug: string;
};

export const ORDER_STATUSES = {
  PLACED: { key: "placed", label: "Placed" },
  IN_PROGRESS: { key: "in-progress", label: "In Progress" },
  COMPLETE: { key: "complete", label: "Completed" },
} as const;
export type OrderStatus =
  (typeof ORDER_STATUSES)[keyof typeof ORDER_STATUSES]["key"];

export type OrderGSI1KeyComponents = {
  type: typeof SITE_DATA_PARTITIONS.ORDER;
  orderStatus: OrderStatus;
  createdAt: string;
};

export type OrderData = OrderKeyComponents &
  OrderGSI1KeyComponents & {
    items: ArtData[];
    originalItems: ArtData[];
    // date: string;
    updatedAt: string;
    contactEmail?: string;
    userId?: string;
    // cusId?: string;
    pi?: string;
    // confirmed?: boolean;
    deliveryLocation?: LocationData;
    checkoutId: string;
    payment: DoridiumCheckout["payment"];
  };

export type OrderDBData = OrderKey & OrderData;
